/**
 * Created by Allan on 2026/07/16.
 * Contact 84880528@qq.com.
 * 智利/PréstaMate移动H5项目
 */
import Vue from 'vue'
import App from './App'
import router from '@/prestamate/router/'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/prestamate/filters/'
import Http from '@/config/Http'
import getQueryString from "@/config/getQueryString";

Vue.use(Vant);
Vue.prototype.$http = Http;
Vue.prototype.$token = getQueryString(location.hash, "token") || '';
Vue.prototype.$appid = getQueryString(location.hash, "appId") || '';
Vue.config.productionTip = false

router.afterEach((to,from,next) => {
    if(to.name==='detail' || to.name==='orderdetails'){
        window.scrollTo(0,0);
    }
});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/prestamate/main.js